module.exports = __webpack_public_path__ + "static/media/shea.c8878f48.png";